import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/images/common/logo_wht.svg'


const _hoisted_1 = { class: "l-footer" }
const _hoisted_2 = { class: "ha-footer" }
const _hoisted_3 = { class: "ha-footer__main" }
const _hoisted_4 = { class: "ha-footer__container" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "ha-footer__logo" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "SHUEISHA ID"
  })
], -1)
const _hoisted_6 = { class: "ha-footer__nav" }
const _hoisted_7 = { class: "ha-footer__navmenu" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", null, "集英社ID利用規約", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://www2.shueisha.co.jp/privacy/privacy.html",
    target: "_blank"
  }, [
    /*#__PURE__*/_createElementVNode("span", null, "集英社プライバシーガイドライン")
  ])
], -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", null, "よくあるご質問", -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", null, "お問い合わせ", -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "ha-footer__copyright" }, "© SHUEISHA Inc. All rights reserved.", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("footer", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("ul", _hoisted_7, [
              _createElementVNode("li", null, [
                _createVNode(_component_router_link, {
                  tag: "a",
                  to: { name: 'Terms' },
                  target: "_blank"
                }, {
                  default: _withCtx(() => [
                    _hoisted_8
                  ]),
                  _: 1
                })
              ]),
              _hoisted_9,
              _createElementVNode("li", null, [
                _createVNode(_component_router_link, {
                  tag: "a",
                  to: { name: 'Help' },
                  target: "_blank"
                }, {
                  default: _withCtx(() => [
                    _hoisted_10
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("li", null, [
                _createVNode(_component_router_link, {
                  tag: "a",
                  to: { name: 'Contact' },
                  target: "_blank"
                }, {
                  default: _withCtx(() => [
                    _hoisted_11
                  ]),
                  _: 1
                })
              ])
            ])
          ])
        ])
      ]),
      _hoisted_12
    ])
  ]))
}